import { Component, Inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    imports: [RouterOutlet, HomeComponent,  FooterComponent]
})
export class AppComponent {
  title = 'GrammarIn';
  public url = '';
  constructor(
  private activatedRoute: ActivatedRoute,private translate: TranslateService,
    private titleService: Title,private router: Router,private metaService: Meta,
    @Inject(DOCUMENT) private dom,
  ) { 

    this.translate.setDefaultLang('en'); 
    this.translate.use('en');
    this.translate.setDefaultLang('en');
const browserLang = this.translate.getBrowserLang() || 'en';
this.translate.use(browserLang);
this.setHtmlLang(browserLang);
    
  }
private setHtmlLang(lang: string): void {
  this.dom.documentElement.lang = lang;
}


  public ngOnInit() {
     const browserLang = this.translate.getBrowserLang();
  const defaultLang = browserLang.match(/en|fr|de|es/) ? browserLang : 'en';

  this.translate.setDefaultLang('en');
  this.translate.use(defaultLang);
  this.setHtmlLang(defaultLang);
  this.translate.onLangChange.subscribe(langEvent => {
    this.setHtmlLang(langEvent.lang);
  });


    const hostName="https://www.grammarin.com"
    //  console.log('Initial App State', this.appState.state);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    )
      .subscribe(() => {
 
        var rt = this.getChild(this.activatedRoute)
 
        rt.data.subscribe(data => {
          this.titleService.setTitle(data.title)
          if (data.title) {
            this.metaService.updateTag({ name: 'title', content: data.title })
          } else {
            this.metaService.removeTag("name='title'")
          }
 
 
          if (data.descrption) {
            this.metaService.updateTag({ name: 'description', content: data.descrption })
          } else {
            this.metaService.removeTag("name='description'")
          }
 
          // if (data.robots) {
          //   this.metaService.updateTag({ name: 'robots', content: data.robots })
          // } else {
          //   this.metaService.updateTag({ name: 'robots', content: "follow,index" })
          // }
 
          if (data.ogUrl) {
            this.metaService.updateTag({ property: 'og:url', content: data.ogUrl })
          } else {
            this.metaService.updateTag({ property: 'og:url', content: this.router.url })
          }
          if (data.ogTitle) {
            this.metaService.updateTag({ property: 'og:title', content: data.ogTitle })
          } else {
            this.metaService.removeTag("property='og:title'")
          }
          if (data.ogDescription) {
            this.metaService.updateTag({ property: 'og:description', content: data.ogDescription })
          } else {
            this.metaService.removeTag("property='og:description'")
          }
          if (data.ogImage) {
            this.metaService.updateTag({ property: 'og:image', content: data.ogImage })
          } else {
            this.metaService.removeTag("property='og:image'")
          }
          if (data.twittertitle) {
            this.metaService.updateTag({ name: 'twitter:title', content: data.twittertitle })
          } else {
            this.metaService.removeTag("name='twitter:title'")
          }
          if (data.twitterdescription) {
            this.metaService.updateTag({ name: 'twitter:description', content: data.twitterdescription })
          } else {
            this.metaService.removeTag("name='twitter:description'")
          }
          if (data.twitterImage) {
            this.metaService.updateTag({ name: 'twitter:image', content: data.twitterImage })
          } else {
            this.metaService.removeTag("name='twitter:image'")
          }
          if (data.canonical) {
            this.updateCanonicalUrl(data.canonical);
          } else {
            this.updateCanonicalUrl(this.router.url);
          }
        })
 
      })
 
  
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
      )
        .subscribe(() => {
          var rt = this.getChild(this.activatedRoute)
          rt.data.subscribe(data => {
            //  console.log(data, 'what is data');
            // this.titleService.setTitle(data.title)
          })  
        })

  }
  updateCanonicalUrl(url:string){
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement= this.dom.querySelector(`link[rel='canonical']`) || null
    if (element==null) {
      element= this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel','canonical')
    element.setAttribute('href',url)
  }
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  
  }
  
}
